import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Modal } from 'semantic-ui-react';

import newUserSchema from '../../../schemas/newUser';
import addUserShape from '../../../shapes/addUserShape';
import SnukForm from '../../reusable/SnukForm';

const NewUserModal = (props) => {
  const {
    t, createNewUser, closeNewUserModal, users,
  } = props;
  const { validation, isPendingAdd } = users;
  return (
    <Modal open size="tiny">
      <Modal.Header className="modal-header">
        {t('usersConfig.add')}
      </Modal.Header>
      <Modal.Content>
        <SnukForm
          schema={newUserSchema}
          shape={addUserShape}
          isPending={isPendingAdd}
          btnText={t('common.add')}
          iconName="add"
          onCancelAction={closeNewUserModal}
          onSubmitAction={createNewUser}
          externalMessage={{
            isError: validation.isError,
            messages: validation.message.length ? [validation.message] : [],
          }}
        />
      </Modal.Content>
    </Modal>
  );
};

NewUserModal.propTypes = {
  t: PropTypes.func.isRequired,
  closeNewUserModal: PropTypes.func.isRequired,
  createNewUser: PropTypes.func.isRequired,
  users: PropTypes.shape({}).isRequired,
};

export default translate()(NewUserModal);



// WEBPACK FOOTER //
// ./src/components/Settings/users/NewUserModal.js